// @ts-strict-ignore
import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useApolloClient, gql, useMutation } from "@apollo/client";

import clearApolloStore from "app/utils/clearApolloStore";

import { RemoveRefreshTokenCookieLogoutMutation, RemoveRefreshTokenCookieLogoutMutationVariables } from "app/GraphqlGeneratedTypes/types";

import AccountDropdownMenu from "../AccountDropdownMenu/AccountDropdownMenu";
import Avatar from "app/components/concept/Avatar/Avatar";
import PageContainer from "app/pages/AppDashboard/components/PageContainer/PageContainer";
import SupportDropdownMenu from "../SupportDropdownMenu/SupportDropdownMenu";

import classes from "./style.scss";

const REMOVE_REFRESH_TOKEN_COOKIE_GQL = gql`
	mutation removeRefreshTokenCookieLogout {
		removeRefreshTokenCookie
	}
`;

const headerMenus = {
	support: "support",
	account: "account"
};

const AppHeader = ({
	activeUser,
	history,
	onBurgerClick,
	isBurgerActive
}) => {
	const apolloHookClient = useApolloClient();

	const ignoreSupportButtonRef = useRef<HTMLDivElement>(null);
	const ignoreAccountButtonRef = useRef<HTMLDivElement>(null);

	const [removeRefreshTokenCookieMutation] = useMutation<
	RemoveRefreshTokenCookieLogoutMutation, RemoveRefreshTokenCookieLogoutMutationVariables
	>(REMOVE_REFRESH_TOKEN_COOKIE_GQL);

	const [clickedHeaderMenu, setClickedHeaderMenu] = useState(null);

	const onLogOutClick = async (e) => {
		e.preventDefault();

		await removeRefreshTokenCookieMutation();
		
		clearApolloStore(apolloHookClient);

		history.block(true);

		localStorage.removeItem("dcbyte-jwt");
		
		history.replace("/");
	};

	const onClickAvatar = () => setClickedHeaderMenu((oldState) => {
		return oldState === headerMenus.account ? null : headerMenus.account;
	});

	const onClickSupport = () => setClickedHeaderMenu((oldState) => {
		return oldState === headerMenus.support ? null : headerMenus.support;
	});

	return (
		<div className={classes.headerContainer}>
			<PageContainer className={classes.headerPageContainer}>
				<Link to={activeUser ? "/dashboard" : "/login"} className={classes.logo}>
					<img
						className={classes.logoImage}
						src="/assets/images/branding/dcbyte-logo-new-colored.svg"
						alt="dcbyte-logo"
						role="img"
						aria-label="logo"
						width="141.63px"
						height="42px"
					/>
				</Link>

				{activeUser
					? <div className={`${classes.supportItemContainer} ${classes.supportContainer}`} >
						<div
							className={`${classes.supportIcon}${clickedHeaderMenu === headerMenus.support ? ` ${classes.outerBorder}` : ""}`}
							onClick={onClickSupport}
							ref={ignoreSupportButtonRef}
						>
							<i className="fa-sharp fa-regular fa-circle-question fa-lg"/>

							<span className={classes.notificationDot}/>
						</div>

						{clickedHeaderMenu === headerMenus.support
							? <SupportDropdownMenu setClickedHeaderMenu={setClickedHeaderMenu} ignoreRef={ignoreSupportButtonRef}/>
							: null
						}
					</div>
					: null
				}

				<div className={`${classes.headerItemContainer} ${classes.profileContainer}`}>
					<Avatar
						user={activeUser}
						onClick={onClickAvatar}
						isClicked={clickedHeaderMenu === headerMenus.account}
						containerRef={ignoreAccountButtonRef}
					/>

					{clickedHeaderMenu === headerMenus.account
						? <AccountDropdownMenu
							activeUser={activeUser}
							setClickedHeaderMenu={setClickedHeaderMenu}
							onLogOutClick={onLogOutClick}
							ignoreRef={ignoreAccountButtonRef}
						/>
						: null
					}
				</div>

				<div
					className={`${classes.hamburger} ${classes.hamburgerSpin} ${isBurgerActive ? classes.isActive : null}`}
					onClick={onBurgerClick}
				>
					<span className={classes.hamburgerBox}>
						<span className={classes.hamburgerInner}>

						</span>
					</span>
				</div>
			</PageContainer>
		</div>
	);
};

AppHeader.propTypes = {
	activeUser: PropTypes.object,
	history: PropTypes.object,
	onBurgerClick: PropTypes.func,
	isBurgerActive: PropTypes.bool,
	disableMaxWidth: PropTypes.bool
};

export default AppHeader;
